import React from 'react';
import MuiInput, { InputProps as MuiProps } from '@material-ui/core/Input';

export interface InputProps extends MuiProps {
    /**
     * If `true`, the input will not have an underline.
     */
    disableUnderline?: boolean;
}

const Input: React.FC<InputProps> = (props: InputProps) => <MuiInput {...props} />;

export default Input;
